import apiClient from "./middleware";

export type AssetHierarchyType =
  | "music_video"
  | "sound_recording"
  | "composition";

export type AssetOwnershipType =
  | "general"
  | "mechanical"
  | "performance"
  | "synchronization"
  | "synchronisation";

export interface AssetScraperExplorerFilters {
  assetType?: AssetHierarchyType;
  ownerQuery?: string;
  ownershipType?: AssetOwnershipType;
  territory?: string;
  q?: string;
}

export interface AssetScraperExplorerRow {
  musicVideoAssetTitle: string | null;
  musicVideoAssetId: string;
  soundRecordingAssetTitle: string | null;
  soundRecordingAssetId: string | null;
  compositionAssetTitle: string | null;
  compositionAssetId: string | null;
  compositionWriters: string | null;
  musicVideoOwnersGlobal: string | null;
  soundRecordingOwnersGlobal: string | null;
  musicVideoOwnershipSelected: string | null;
  soundRecordingOwnershipSelected: string | null;
  compositionOwnershipSelected: string | null;
  compositionSyncUs: string | null;
  compositionSyncExUs: string | null;
  compositionSyncRawAll: string | null;
}

export interface AssetScraperExplorerResponse {
  jobId: string;
  datasetId: string;
  tableName: {
    metadata: string;
    ownership: string;
    references: string;
  };
  filters: AssetScraperExplorerFilters;
  limit: number;
  offset: number;
  total: number;
  rows: AssetScraperExplorerRow[];
}

export interface AssetScraperExplorerAggregatesResponse {
  jobId: string;
  datasetId: string;
  tableName: {
    metadata: string;
    ownership: string;
    references: string;
  };
  filters: AssetScraperExplorerFilters;
  totals: {
    musicVideos: number;
    withSoundRecording: number;
    withComposition: number;
    compositionSyncUsRows: number;
    compositionSyncExUsRows: number;
  };
  ownershipRowsByType: Array<{
    ownershipType: AssetOwnershipType;
    rowCount: number;
  }>;
}

export const assetScraperExplorerApi = {
  getJobExplorer: async (
    jobId: string,
    params?: AssetScraperExplorerFilters & { limit?: number; offset?: number }
  ): Promise<AssetScraperExplorerResponse> => {
    const { data } = await apiClient.get(
      `/scrapers/music-asset-scraper/jobs/${jobId}/explorer`,
      { params }
    );
    return data;
  },

  getJobExplorerAggregates: async (
    jobId: string,
    params?: AssetScraperExplorerFilters
  ): Promise<AssetScraperExplorerAggregatesResponse> => {
    const { data } = await apiClient.get(
      `/scrapers/music-asset-scraper/jobs/${jobId}/explorer/aggregates`,
      { params }
    );
    return data;
  },
};

